export const isValidUrl = (url?: string): boolean => {
  // Check if the url is a valid url or not.
  return /^https?:\/\//.test(url || '');
};
